import script from "./Partner.vue?vue&type=script&setup=true&lang=js"
export * from "./Partner.vue?vue&type=script&setup=true&lang=js"

import "./Partner.vue?vue&type=style&index=0&id=2fdcdb18&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdcdb18"]])

export default __exports__